export default __webpack_public_path__ + "static/media/reset_pass.6c1b4e15.svg";